import script from "./ProfessionalDevelopmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalDevelopmentPage.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalDevelopmentPage.vue?vue&type=style&index=0&id=0b525cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b525cc4"]])

export default __exports__